import { gql } from '@apollo/client';

// Persists the leadership program panels (Business / Collective / Neighbouring) for a
// relationship. Replace-all.
export const UPDATE_PARTNERSHIP_PROGRAMS = gql`
mutation UpdatePartnershipPrograms($supporterId: Int!, $programs: [PartnershipProgramInput!]) {
  updatePartnershipPrograms(supporterId: $supporterId, programs: $programs) {
    id
  }
}`;
